export const componentTypes = {
  TEXT: 'text',
  IMAGE: 'image',
  BUTTON: 'button',
  BULLETLIST: 'Bullet list',
  YOUTUBE: 'youtube',
  MP4VIDEO: 'mp4',
  INSTAGRAM: 'instagram',
  SPOTIFY: 'spotify',
  SOUNDCLOUD: 'soundcloud',
  TIKTOK: 'tiktok',
  BAINREFERRALBANNER: 'bain referral banner',
  BORDERBANNER: 'border banner',
  ADVERTISERDISCLOSURE: 'advertiser disclosure',
  ACCORDION: 'accordion',
  CURRENTDATE: 'current date',
  LOTTIE: 'lottie',
  THIRDPARTYEMBED: 'Third Party Embed',
  INPUTBUTTON: 'Input Button',
  RETIREMENTCALCULATORSC: 'Retirement Calculator SC',
};
